import { clearStorageData } from './clearStorageData';
import { getValidatedBase64Cookie } from '@shared/cookies/getValidatedBase64Cookie';
import { encodeToBase64 } from '@shared/conversion/encodeToBase64';
import { consoleLogger } from '@shared/logging/consoleLogger';
import { createCookie } from '@shared/cookies/createCookie';
import { UtiqStatusEntryName } from '@shared/constants/utiq';
import { getLoggingLevelCookieName } from '@shared/logging/getLoggingLevelCookieName';
import { getBaseDomain } from '@shared/domain/getBaseDomain';
import { setVersionCookies } from '@utiqLoader/helpers/setVersionCookies';

export const handleDataClear = () => {
  consoleLogger.logInfo('Data clear request made. Clearing the Utiq data...');
  const consentStatusCookieBeforeClear = getValidatedBase64Cookie(
    document.cookie,
    UtiqStatusEntryName,
  );

  const isConsentRejectedAlready = consentStatusCookieBeforeClear
    ? consentStatusCookieBeforeClear === 'false'
    : true;

  if (!isConsentRejectedAlready) {
    document.cookie = createCookie({
      name: UtiqStatusEntryName,
      value: encodeToBase64(false),
      days: 180,
      domain: getBaseDomain(window.location.hostname),
    });
  }

  setVersionCookies();

  /* Clear IDConnect local storage data */
  clearStorageData();

  const loggingLevelCookieName = getLoggingLevelCookieName();
  const loggingLevelCookieValue = getValidatedBase64Cookie(
    document.cookie,
    loggingLevelCookieName,
  );
  const isLoggingLevelAlreadyVerbose = loggingLevelCookieValue
    ? loggingLevelCookieValue === 'verbose'
    : false;
  if (isLoggingLevelAlreadyVerbose) {
    document.cookie = createCookie({
      name: loggingLevelCookieName,
      value: encodeToBase64('info'),
      days: 0,
    });
  }
};
